module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-carnation-df1c4b52de8a3de6a159b7050ac65a2f.svg";